import * as tslib_1 from "tslib";
import loader from "@/components/loader.vue";
import { Getter } from "vuex-class";
import { Vue, Component } from "vue-property-decorator";
import profileImage from "@/components/profileImage.vue";
let widget = class widget extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.confirmDeleteProfile = false;
        this.confirmDeleteProfileID = 0;
    }
    age(year) {
        return new Date().getFullYear() - year;
    }
    genderIcon(p) {
        switch (String(p.gender).toLowerCase()) {
            case "male":
                return "M";
            case "female":
                return "F";
        }
        return null;
    }
    showDeleteProfile(profileID) {
        this.confirmDeleteProfile = true;
        this.confirmDeleteProfileID = profileID;
    }
};
tslib_1.__decorate([
    Getter("auth/profiles")
], widget.prototype, "profiles", void 0);
widget = tslib_1.__decorate([
    Component({
        components: {
            loader,
            profileImage,
            dialogDeleteProfile: () => import(/* webpackChunkName: "dialog-deleteProfile" */ "@/dialogs/deleteProfile.vue")
        }
    })
], widget);
export default widget;
